import React, {useState} from 'react'
import Text from '../../components/text/Text'
import {IProbeCall} from './types'
import {callBodyText, copyProbeText, formatProbeTime, isFailedCall} from './utils'

interface IProps {
    call: IProbeCall
}

const statusStyle = (call: IProbeCall) => {
    if (call.error || call.http_status === 0) return 'text-font_red bg-tag_red_light'
    if (call.http_status >= 400) return 'text-font_red bg-tag_red_light'
    if (isFailedCall(call)) return 'text-font01 bg-[#FDF3D9]'
    return 'text-font_green bg-tag_green_light'
}

// 한 번의 왕복. 바디가 핵심이지만 호출이 수십 개라 접어두고, 의심스러운 것만 펼친 채로 시작한다.
const CallItem: React.FC<IProps> = ({call}) => {
    const [open, setOpen] = useState(isFailedCall(call))
    const body = callBodyText(call)

    return (
        <div className={'rounded-[8px] border border-line02'}>
            <div
                onClick={() => setOpen(!open)}
                className={'flex items-center gap-x-[10px] px-[16px] py-[12px] cursor-pointer hover:bg-bg_gray02'}>
                <Text className={'text-ti3 text-font03 w-[16px] flex-none'}>{open ? '▾' : '▸'}</Text>
                {call.phase && (
                    <Text className={'text-ti3 px-[7px] py-[2px] rounded-[5px] text-font02 bg-bg_gray01 flex-none'}>
                        {call.phase}
                    </Text>
                )}
                <Text className={'text-ti3 text-font02 w-[50px] flex-none'}>{call.method}</Text>
                <Text className={'text-body3 text-font01 truncate flex-1'}>{call.url}</Text>
                {call.truncated && (
                    <Text className={'text-ti3 px-[7px] py-[2px] rounded-[5px] text-white bg-tag_orange flex-none'}>
                        truncated
                    </Text>
                )}
                <Text className={`text-ti3 px-[7px] py-[2px] rounded-[5px] flex-none ${statusStyle(call)}`}>
                    {call.http_status || 'ERR'}
                </Text>
                <Text className={'text-body3 text-font03 w-[70px] text-right flex-none'}>{call.duration_ms}ms</Text>
            </div>

            {open && (
                <div className={'border-t border-line02 px-[16px] py-[12px] space-y-[10px]'}>
                    <div className={'flex items-center gap-x-[10px] flex-wrap'}>
                        <Text className={'text-body3 text-font03 break-all flex-1'}>{call.url}</Text>
                        <Text className={'text-body3 text-font03'}>{formatProbeTime(call.at)}</Text>
                        <Text
                            onClick={() => copyProbeText(body, '응답 바디가')}
                            className={'text-body3 text-sub_blue cursor-pointer whitespace-nowrap'}>
                            바디 복사
                        </Text>
                    </div>

                    {/* transport 단계에서 실패한 경우 — 바디가 아예 없다. */}
                    {call.error && <Text className={'text-body2 text-font_red'}>{call.error}</Text>}

                    {call.truncated && (
                        <Text className={'text-body3 text-font02'}>
                            바디가 256KB를 넘어 잘렸습니다. 아래는 앞부분입니다.
                        </Text>
                    )}

                    {body ? (
                        <pre
                            className={
                                'text-body3 font-mono whitespace-pre-wrap break-all bg-line04 rounded-[6px] p-[12px] max-h-[400px] overflow-y-auto'
                            }>
                            {body}
                        </pre>
                    ) : (
                        !call.error && <Text className={'text-body3 text-font03'}>바디 없음</Text>
                    )}
                </div>
            )}
        </div>
    )
}

export default CallItem
